import { h } from "snabbdom";
import type { VNode } from "snabbdom";
import type { Model, Msg } from "../types";
import { viewTopbar } from "./topbar";
import { viewCard } from "./card";
import { viewModal } from "./modal";
import { viewConfirmDelete } from "./confirm";
import { viewViewBlockDialog } from "./view-block-dialog";
import { viewLinkDialog } from "./link-dialog";
import { viewTagsPage } from "./tags-page";
import { viewSettingsPage } from "./settings-page";
import { viewRegistryConflicts } from "./registry-conflicts";

export function view(model: Model, dispatch: (msg: Msg) => void): VNode {
  return h("div#app", [
    viewTopbar(model, dispatch),
    h("main.main", [
      model.route === "tags"
        ? viewTagsPage(model, dispatch)
        : model.route === "settings"
        ? viewSettingsPage(model, dispatch)
        : model.currentCardId
        ? viewCard(model, dispatch)
        : h("div.empty-state", "Select or create a card to get started."),
    ]),
    ...(model.modal ? [viewModal(model.modal, dispatch)] : []),
    ...(model.viewBlockDialog ? [viewViewBlockDialog(model.viewBlockDialog, dispatch)] : []),
    ...(model.linkDialog ? [viewLinkDialog(model.linkDialog, dispatch)] : []),
    ...(model.deleteConfirmId ? [viewConfirmDelete(model.deleteConfirmId, dispatch)] : []),
    ...(model.registryConflicts ? [viewRegistryConflicts(model.registryConflicts, dispatch)] : []),
    ...(model.toasts.length ? [viewToasts(model, dispatch)] : []),
  ]);
}

// Error toasts, bottom-left, newest at the bottom. Each is dismissible.
function viewToasts(model: Model, dispatch: (msg: Msg) => void): VNode {
  return h(
    "div.toasts",
    model.toasts.map((t) =>
      h("div.toast", { key: t.id }, [
        h("span.toast__msg", t.message),
        h(
          "button.toast__close",
          { attrs: { title: "Dismiss" }, on: { click: () => dispatch({ type: "DismissToast", id: t.id }) } },
          "×"
        ),
      ])
    )
  );
}
